import React from 'react';
import VenueConductorPage from '../components/VenueConductorPage';

const VenueConductorApp = (props) => <VenueConductorPage {...props} />;

export default VenueConductorApp;
